import React from 'react'
import { resolveIconNode, RsIcon } from '../../components/icons'

export function trendDirFromPct(pct) {
  if (pct == null || pct === '') return 'up'
  return String(pct).trim().startsWith('-') ? 'down' : 'up'
}

/** KPI card aligned with ui-prototype (kpi-card + kpi-header) */
export function AdminKpiCard({ icon, color = 'blue', label, value, trend, trendDir = 'up' }) {
  return (
    <div className="admin-kpi-card admin-kpi-card-rich">
      <div className="admin-kpi-header">
        <span className={`admin-kpi-icon ${color}`}>{resolveIconNode(icon, { size: 'md' })}</span>
        {trend != null && trend !== '' && (
          <span className={`admin-kpi-trend ${trendDir}`}>{trend}</span>
        )}
      </div>
      <div className="admin-kpi-value">{value}</div>
      <div className="admin-kpi-label">{label}</div>
    </div>
  )
}

/** Horizontal stat card (Analytics / User List design) */
export function AdminStatCardFlex({ icon, cls, label, value, sub, trend, trendDir = 'up' }) {
  return (
    <div className="admin-analytics-stat">
      <div className={`admin-analytics-stat-icon ${cls}`}>{resolveIconNode(icon, { size: 'md' })}</div>
      <div className="admin-analytics-stat-info">
        <div className="label">{label}</div>
        <div className="value">{value}</div>
        {sub != null && sub !== '' && <div className="sub">{sub}</div>}
        {trend != null && trend !== '' && (
          <div className="sub">
            <span className={trendDir === 'down' ? 'trend-down' : 'trend-up'}>
              <RsIcon name={trendDir === 'down' ? 'trendDown' : 'trendUp'} size="xs" />
              {' '}
              {String(trend).replace(/^\+/, '')}
            </span>
            {' '}
            vs last period
          </div>
        )}
      </div>
    </div>
  )
}
